export default {
  id: null,
  descricao: null,
  items: [],
  empresaID: null,
  status: 1
}



// WEBPACK FOOTER //
// ./src/shared/models/pci/layoutmodel.js